export const FORM_DRAFT_STORAGE_PREFIX = "nw_form_draft_";
export const FORM_DRAFT_STORAGE_VERSION = 1;
export const FORM_DRAFT_EXPIRY_DAYS = 7;
export const FORM_DRAFT_AUTOSAVE_DELAY_MS = 500;
/** Hard size cap on draft payloads. Mirrors the DB CHECK on form_drafts.draft_data. */
export const FORM_DRAFT_MAX_BYTES = 262144;
/**
 * Reserved `draft_data`/`draftData` key holding a snapshot of each field's type at save
 * time, keyed by field label (the same keys the draft's answers use). Never a real field's
 * answer — see `dropStaleTypedDraftValues` for why it's there.
 */
export const DRAFT_FIELD_TYPES_KEY = "__fieldTypes__";
